import React from 'react';
import {ActivityIndicator} from 'react-native';
import {useTheme} from 'styled-components/native';
import {Button} from '../../Buttons/Button';

import {
  Container,
  InputContainer,
  Input,
  CloseButton,
  Icon,
  ButtonContainer,
} from './styles';
import {TextInputMaskProps} from 'react-native-text-input-mask';

interface IInput2 extends TextInputMaskProps {
  buttonText: string;
  enabled: boolean;
  onButtonPress: () => void;
  showCloseButton?: boolean;
  loading?: boolean;

  onCloseButtonPress?: () => void;
}

export function InputWithButton({
  onButtonPress,
  showCloseButton,
  onCloseButtonPress,

  enabled,
  loading,
  buttonText,
  ...rest
}: IInput2) {
  const theme = useTheme();

  return (
    <Container>
      <InputContainer>
        <Input {...rest} placeholderTextColor={theme.colors.text} />
        {loading ? (
          <ActivityIndicator color={theme.colors.text} />
        ) : (
          showCloseButton && (
            <CloseButton onPress={onCloseButtonPress}>
              <Icon name="x" />
            </CloseButton>
          )
        )}
      </InputContainer>
      {!showCloseButton && (
        <ButtonContainer>
          <Button
            title={buttonText}
            enabled={enabled}
            onPress={onButtonPress}
          />
        </ButtonContainer>
      )}
    </Container>
  );
}
